import React, {useContext} from 'react'
import { ElementContext } from '../ElementContext';
import Modal from 'react-modal';
import { useTranslation } from 'react-i18next';
import { fetchBackend } from '../../helpers/fetch';
import { useAuth } from '@frontegg/react';
import { getPhoneNumberInformation } from '../../helpers/whatsapp-api';
import { useState } from 'react';

Modal.setAppElement('#root');

const InsertWACredentials = () => {

    const { user } = useAuth();
    const { 
        WACredentialsModal, 
        setWACredentialsModal, 
        userConfiguration, 
        wAPIUserInformation, 
        setwAPIUserInformation, 
        setUserConfiguration 
    } = useContext(ElementContext);
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false)
    const [wrongCredentials, setWrongCredentials] = useState({ ok: false, msg: '' })
    

    const handleSubmitCredentials = async(e) => {
        e.preventDefault()
        setLoading(true)
        
        try {
            const accessToken = document.querySelector('#tokenAccessId').value
            const phoneNumberId = document.querySelector('#phoneidCred').value
            const whatsappBusinessAccountId = document.querySelector('#businessIdCred').value

            const newCredentials = {
                accessToken,
                phoneNumberId,
                whatsappBusinessAccountId
            }

            // 1️⃣ VALIDAR NUEVAS CREDENCIALES PRIMERO
            const whatsappApiPhoneNumber = await getPhoneNumberInformation(newCredentials)
            
            if(whatsappApiPhoneNumber.error){
                setWrongCredentials({
                    ok: true,
                    msg: 'El token es inválido o está vencido'
                })
                setLoading(false)
                return
            }

            // 2️⃣ OBTENER CONFIGURACIÓN ACTUAL
            const configRequest = await fetchBackend(`settings/${user.email}`)
            const configResponse = await configRequest.json()

            if (!configResponse.ok || !configResponse.data?.length) {
                setWrongCredentials({ ok: true, msg: 'No se pudo cargar la configuración actual' })
                setLoading(false)
                return
            }

            const dbConfig = JSON.parse(configResponse.data[0].configuracion)
            const activeCredentials = dbConfig.whatsappAPIcredentials || []

            // 3️⃣ ACTUALIZAR O AGREGAR CREDENCIALES
            const updatedCredentials = activeCredentials.some(
                cred => cred.phoneNumberId === phoneNumberId
            )
                ? activeCredentials.map(cred =>
                    cred.phoneNumberId === phoneNumberId ? newCredentials : cred
                )
                : [...activeCredentials, newCredentials]

            // 4️⃣ PREPARAR SETTINGS ACTUALIZADOS
            const settings = {
                ...dbConfig,
                whatsappAPIcredentials: updatedCredentials,
                selectedWACredentials: phoneNumberId
            }

            // 5️⃣ GUARDAR EN DB
            const data = { email: user.email, settings: JSON.stringify(settings) }
            const saveConfigurationRequest = await fetchBackend('settings', {data}, 'PUT')
            const saveConfigurationResponse = await saveConfigurationRequest.json()

            if(!saveConfigurationResponse.ok){
                throw new Error('Error al guardar configuración')
            }

            // 6️⃣ ACTUALIZAR INFORMACIÓN DE TODAS LAS CREDENCIALES
            const WAPIUserInfo = []
            for(let credentials of updatedCredentials){
                try {
                    const phoneInfo = await getPhoneNumberInformation(credentials)
                    if(!phoneInfo.error){
                        WAPIUserInfo.push(phoneInfo)
                    } else {
                        // Agregar credencial con error
                        WAPIUserInfo.push({
                            id: credentials.phoneNumberId,
                            verified_name: 'Credencial existente',
                            display_phone_number: '-',
                            code_verification_status: 'TOKEN_EXPIRED',
                            __localCredential: credentials,
                            __status: 'INVALID'
                        })
                    }
                } catch (error) {
                    console.error('Error al obtener info de credencial:', error)
                    WAPIUserInfo.push({
                        id: credentials.phoneNumberId,
                        verified_name: 'Credencial existente',
                        display_phone_number: '-',
                        code_verification_status: 'ERROR',
                        __localCredential: credentials,
                        __status: 'INVALID'
                    })
                }
            }
            
            setwAPIUserInformation(WAPIUserInfo)
            setUserConfiguration(settings) // Usar el settings ya preparado
            
            // Limpiar formulario
            document.querySelector('#tokenAccessId').value = ''
            document.querySelector('#phoneidCred').value = ''
            document.querySelector('#businessIdCred').value = ''
            
            setWrongCredentials({ ok: false, msg: '' })
            setWACredentialsModal(false)
            
        } catch (error) {
            console.error('Error en handleSubmitCredentials:', error)
            setWrongCredentials({ 
                ok: true, 
                msg: error.message || 'Error al guardar las credenciales' 
            })
        } finally {
            setLoading(false)
        }
    }

    const handleCloseForm = (e) => {
        e.preventDefault()
        setWrongCredentials({ ok: false, msg: '' })
        setWACredentialsModal(false)
    }


  return (
    <Modal
        isOpen={ WACredentialsModal }
        className="modal-mfa p-4"
        overlayClassName="modal-fondo"
    >
        <h4 className='text-center text-mediumblue mb-4'>
            {t('wApiCredentialsTitle')}
        </h4>

        <small className='text-justify border-top d-block py-3'>
            {t('wApiCredentialsSubtitle2')}.
        </small>
        {
            wrongCredentials.ok && (
                <div className="alert alert-danger" role="alert">
                    { wrongCredentials.msg }
                </div>
            )
        }

        <form onSubmit={ handleSubmitCredentials }>
            <div className="d-flex flex-column mt-2 mb-3">
                <label htmlFor="tokenAccessId">
                    <small className='credentials-label'>{t('accessToken')}</small>
                </label>
                <input
                    disabled={loading}
                    autoComplete='off'
                    id='tokenAccessId'
                    type="text"
                    className='form-control text-center'
                    required
                />
            </div>
            
            <div className="d-flex flex-column mt-2 mb-3">
                <label htmlFor="businessIdCred">
                    <small className='credentials-label'>{t('wAccountId')}</small>
                </label>
                <input
                    disabled={loading}
                    autoComplete='off'
                    id='businessIdCred'
                    type="text"
                    className='form-control text-center'
                    required
                />
            </div>
        
            <div className="d-flex flex-column mt-2 mb-3">
                <label htmlFor="phoneidCred">
                    <small className='credentials-label'>{t('phoneId')}</small>
                </label>
                <input
                    disabled={loading}
                    autoComplete='off'
                    id='phoneidCred'
                    type="text"
                    className='form-control text-center'
                    required
                />
            </div>

            <div className='d-flex justify-content-center align-items-center mt-4'>
                <button
                    type='submit'
                    className='btn btn-lightblue btn-sm me-3'
                    disabled={loading}
                >
                    {
                        loading ? (
                            <>
                                <span className='text-light'>{t('processing')}...</span>
                                <div className="spinner-border text-light loading-button ms-2" role="status">
                                    <span className="visually-hidden">...</span>
                                </div>
                            </>
                        ) : t('save')
                    }
                </button>

                <button
                    className='btn btn-91 btn-sm me-3'
                    onClick={ handleCloseForm }
                    disabled={loading}
                >
                    {t('close')}
                </button>
            </div>
        </form>
    </Modal>
  )
}

export default InsertWACredentials